import React from 'react';
import convertUnicodeToEmoji from '@lib/Creators/Dashboard/Workflows/utils';
import Tooltip from '@components/Tooltip';
import s from "./Emoji.module.scss";

type EmojiProps = { unicode: string; title: string; className?: string };

const Emoji: React.FC<EmojiProps> = ({ unicode, title, className }) => {
  // Convert the Unicode string to the actual emoji
  const emoji = convertUnicodeToEmoji(unicode);

  return (
    <Tooltip text={title || "Tag"} alignment="bottom-center" classNameTooltip={s.tooltip} >
      <span
        className={className}
      >
        {emoji}
      </span>
    </Tooltip>
  );
};

export default Emoji;
